// extracted by mini-css-extract-plugin
export default {"list_item_min_height":"56px"};